import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import FullScreenSpinner from "../components/spinners/FullScreenSpinner.tsx";

const Home = lazy(() => import("../pages/home/index.js"));
const Services = lazy(() => import("../pages/services/index.js"));
const Date = lazy(() => import("../pages/date/index.js"));
const Confirmation = lazy(() => import("../pages/confirmation/index.js"));

export const MainRouter = () => {
  return (
    <Suspense fallback={<FullScreenSpinner color={"#DFE9F6"} />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:open" element={<Home />} />
        <Route path="/services/:id" element={<Services />} />
        <Route path="/date" element={<Date />} />
        <Route path="/confirmation" element={<Confirmation />} />
      </Routes>
    </Suspense>
  );
};
